import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { EditorState, Modifier } from 'draft-js';
import classNames from 'classnames';
import styles from './styles.css';
import TokenPanel from './TokenPanel';

const tokenPropTypes = PropTypes.arrayOf(PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.string,
  type: PropTypes.string,
  restrict: PropTypes.bool,
  values: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    type: PropTypes.string,
    restrict: PropTypes.bool,
  })),
}));

// eslint-disable-next-line react/no-multi-comp
class LayoutComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.stopPropagation = this.stopPropagation.bind(this);
    this.addToken = this.addToken.bind(this);
  }


  stopPropagation(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  addToken(token) {
    this.props.addToken(token.editorValue || token.value);
  }

  renderAddImageModal() {
    const { source } = this.props;
    return (
      <div
        className={classNames('rdw-image-modal', styles.editorTagPopup)}
        onClick={this.stopPropagation}
      >
        <div className="rdw-image-modal-header">
          <div><strong>Available Tokens:</strong></div>
        </div>
        <div className="rdw-image-modal-body">
          <TokenPanel
            addToken={this.addToken}
            tokens={this.props.tokens}
            source={source}
          />
        </div>
      </div>
    );
  }

  render() {
    const {
      config: { className, title },
      expanded,
      onExpandEvent,
      translations,
    } = this.props;
    return (
      <div
        className="rdw-image-wrapper"
        aria-haspopup="true"
        aria-expanded={expanded}
        aria-label="rdw-image-control"
      >
        <div
          className={classNames(
            'rdw-option-wrapper',
            className,
            {
              'rdw-option-active': expanded,
            },
          )}
          onClick={onExpandEvent}
          aria-selected={expanded}
          title={title || translations['components.controls.tags.tag']}
        >
          <code style={{ color: '#222', textTransform: 'uppercase', background: 'none' }}>{'{Token}'}</code>
        </div>

        {expanded ? this.renderAddImageModal() : undefined}
      </div>
    );
  }
}

LayoutComponent.propTypes = {
  expanded: PropTypes.bool,
  onExpandEvent: PropTypes.func,
  addToken: PropTypes.func,
  config: PropTypes.shape({}).isRequired,
  translations: PropTypes.shape({}),
  tokens: tokenPropTypes.isRequired,
  source: PropTypes.string,
};

LayoutComponent.defaultProps = {
  expanded: false,
  onExpandEvent: () => {},
  addToken: () => {},
  translations: {},
  source: 'opportunity',
};


// eslint-disable-next-line react/no-multi-comp
class TagControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
    this.expandCollapse = this.expandCollapse.bind(this);
    this.doExpand = this.doExpand.bind(this);
    this.doCollapse = this.doCollapse.bind(this);
    this.addToken = this.addToken.bind(this);
    this.onExpandEvent = this.onExpandEvent.bind(this);
  }

  componentWillMount() {
    const { modalHandler } = this.props;
    modalHandler.registerCallBack(this.expandCollapse);
  }

  componentWillUnmount() {
    const { modalHandler } = this.props;
    modalHandler.deregisterCallBack(this.expandCollapse);
  }

  onExpandEvent() {
    this.signalExpanded = !this.state.expanded;
  }

  doExpand() {
    this.setState({
      expanded: true,
    });
  }

  doCollapse() {
    this.setState({
      expanded: false,
    });
  }

  expandCollapse() {
    this.setState({
      expanded: this.signalExpanded,
    });
    this.signalExpanded = false;
  }

  addToken(text) {
    const { editorState, onChange } = this.props;
    const selectionState = editorState.getSelection();
    const contentState = editorState.getCurrentContent();
    // const contentStateWithEntity = contentState.createEntity('TOKEN', 'SEGMENTED', { token: text });
    // const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    // const modifiedContent = Modifier.insertText(contentState, selectionState, text, null, entityKey);
    const modifiedContent = Modifier.insertText(contentState, selectionState, text);
    const nextState = EditorState.push(editorState, modifiedContent, editorState.getLastChangeType());
    onChange(nextState);
    this.doCollapse();
  }


  render1() {
    // backup
    const { config, translations, tokens, source } = this.props;
    const { expanded } = this.state;
    const LayoutComp = config.component || LayoutComponent;
    if (!LayoutComp) {
      return null;
    }
    return (
      <LayoutComp
        config={config}
        translations={translations}
        addToken={this.addToken}
        expanded={expanded}
        onExpandEvent={this.onExpandEvent}
        doExpand={this.doExpand}
        tokens={tokens}
        source={source}
      />
    );
  }

  render() {
    return (
      <div
        className="rdw-image-wrapper"
        aria-haspopup="true"
        aria-label="rdw-image-control"
      >
        <div
          className={classNames(
            'rdw-option-wrapper',
          )}
          onClick={this.props.onClick}
          title="Tokens"
        >
          <code style={{ color: '#222', textTransform: 'uppercase', background: 'none' }}>{'{Token}'}</code>
        </div>
      </div>
    )
  }
}

TagControl.propTypes = {
  editorState: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func,
  modalHandler: PropTypes.shape(),
  config: PropTypes.shape({}),
  translations: PropTypes.shape({}),
  tokens: tokenPropTypes.isRequired,
  source: PropTypes.string,
  onClick: PropTypes.func,
};
TagControl.defaultProps = {
  config: {},
  onChange: () => {},
  translations: {},
  modalHandler: {},
  source: 'opportunity',
  onClick: () => {},
};

export default TagControl;
